import React, { useMemo } from 'react';
import hljs from 'highlight.js';

/**
 * Highlighted code via hightlight.js
 */
function Highlight({language, children}) {

	if (typeof children !== 'string') {
		throw new Error("Hightlight children must be a string, was: " + typeof children);
	}

	const highlightedCode = useMemo(
		() => hljs.highlight(language, children).value,
		[language, children]
	);
	return <pre><code className="hljs" dangerouslySetInnerHTML={{__html: highlightedCode}}></code></pre>;
}

export default Highlight;